import { useEffect, useState } from 'react'

const RefreshButton = ({ handleClick, updatedOn, className, children }) => {
  const [refreshing, setRefreshing] = useState()

  useEffect(() => {
    setRefreshing(false)
  }, [updatedOn])

  function onClick() {
    setRefreshing(true)
    handleClick()
  }

  return (
    <button disabled={refreshing} className={className} onClick={onClick}>
      {refreshing ? 'Refreshing' : 'Refresh'}
      {children}
    </button>
  )
}

export default RefreshButton
